import { useRuntimeConfig } from "nuxt/app";
import { useTask, timeout } from "vue-concurrency";
import { useSearchStore } from "@/store/search";

export const useSearchTask = () => {
  const config = useRuntimeConfig();
  const searchStore = useSearchStore();
  const searchTask = useTask(function* (_signal) {
    yield timeout(config.public.RESTARTABLE_TIMEOUT as number);
    searchStore.articleSearchRequest();
  }).restartable();

  searchTask.perform();
};
